export enum RideStationType {
  In = "In",
  Out = "Out",
  CatchRideIn = "CatchRideIn",
  CatchRideOut = "CatchRideOut",
  Both = "Both",
  None = "None",
}
